import { useIntl } from 'react-intl';
import {
  Form,
  Row,
  Col,
  FormInstance,
  Input,
  Checkbox,
  Typography,
} from 'antd';

import moment from 'moment';
import FloatingFormItem from '@/components/_common/FloatingFormItem';

import { useDefaultEmptyFieldError } from '@/hooks';
import { InputDate } from '@/components/_common';
import { useProfilesReduced } from '@/core/domain/enterprise/Profiles/Profiles.hooks';
import { useUsers } from '@/core/domain/enterprise/Users/Users.hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { useEffect } from 'react';
import { MessageFormValues } from '@/core/domain/notification/Message/Message.types';

interface Props {
  form: FormInstance<MessageFormValues>;
}

function NotificationForm({ form }: Props) {
  const intl = useIntl();
  const { Title } = Typography;

  const listProfileIds = Form.useWatch('listProfileIds', form);

  const { data } = useProfilesReduced();
  const { data: usersData } = useUsers({ rows: 500 });

  const users = flatInfiniteData(usersData);

  useEffect(() => {
    if (listProfileIds?.length) {
      form.setFieldsValue({
        listUserIds: users
          ?.filter((user) =>
            user.profiles.every((profile) =>
              listProfileIds?.includes(profile.id),
            ),
          )
          .map((user) => user.id),
      });
    }
  }, [listProfileIds, usersData]);

  const defaultEmptyFieldError = useDefaultEmptyFieldError();
  return (
    <>
      <Form layout="vertical" form={form}>
        <Row gutter={[24, 24]}>
          <Col span={24} lg={12}>
            <Row gutter={[0, 9]}>
              <Col span={24}>
                <FloatingFormItem
                  label="Titulo"
                  name="title"
                  rules={[defaultEmptyFieldError]}
                >
                  <Input maxLength={50} showCount />
                </FloatingFormItem>
              </Col>

              <Col span={24}>
                <FloatingFormItem
                  label={intl.formatMessage({
                    id: 'informative.form.mensage',
                  })}
                  name="detail"
                  rules={[defaultEmptyFieldError]}
                >
                  <Input.TextArea rows={4} maxLength={1000} showCount />
                </FloatingFormItem>
              </Col>

              <Col span={24}>
                <FloatingFormItem
                  label={intl.formatMessage({
                    id: 'informative.form.date',
                  })}
                  name="dateTime"
                  rules={[defaultEmptyFieldError]}
                  initialValue={moment()}
                >
                  <InputDate showTime />
                </FloatingFormItem>
              </Col>
            </Row>
          </Col>

          <Col span={24} lg={12}>
            <Row gutter={[24, 24]}>
              <Col span={24}>
                <Form.Item
                  style={{
                    border: 'solid 1px #E2E2E2',
                    borderRadius: '0.5em',
                    padding: '1em',
                  }}
                  label={
                    <Title level={5}>
                      {intl.formatMessage({
                        id: 'informative.form.userGroup',
                      })}
                    </Title>
                  }
                  name="listProfileIds"
                >
                  <Checkbox.Group
                    options={data?.map((profile) => ({
                      value: profile.id,
                      label: profile.name,
                    }))}
                    className="checkbox-user-groups"
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                    }}
                  />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  style={{
                    border: 'solid 1px #E2E2E2',
                    borderRadius: '0.5em',
                    padding: '1em',
                  }}
                  label={
                    <Title level={5}>
                      {intl.formatMessage({
                        id: 'informative.form.user',
                      })}
                    </Title>
                  }
                  name="listUserIds"
                >
                  {!!listProfileIds?.length && (
                    <Checkbox.Group
                      options={users
                        ?.filter((user) =>
                          user.profiles.every((profile) =>
                            listProfileIds?.includes(profile.id),
                          ),
                        )
                        .map((user) => ({
                          value: user.id,
                          label: user.employeeName,
                        }))}
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                      }}
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default NotificationForm;
